/**
 * Definição do book_ia para o registry frontend.
 *
 * Rotas registradas via este módulo:
 *   - /book_ia/preview/:slug  — preview interativo sem mesa (requiredRole: 'any')
 *
 * A rota de sessão real (/mesa/:tableId/book_ia/:sessionId) é registrada
 * diretamente no AppRouter com ProtectedRoute + fullScreen, igual ao padrão
 * do solo_pbta — o BookIaRuntime (shell) é o componente filho direto do
 * ProtectedRoute para receber `user` via cloneElement.
 *
 * Ver docs/book_ia/specs/tasks.md (frontend/T1).
 */

import { lazy } from 'react'

import type { GameModule } from '../types'

const BookPreview = lazy(() => import('./preview/BookPreview'))
const BookIaGeneralConfig = lazy(() =>
  import('./pages/BookIaGeneralConfig').then((m) => ({ default: m.BookIaGeneralConfig }))
)
const BookIaSessionMonitor = lazy(() =>
  import('./pages/BookIaSessionMonitor').then((m) => ({ default: m.BookIaSessionMonitor }))
)

export const BookIaModule: GameModule = {
  manifest: {
    id: 'book_ia',
    name: 'Book IA',
    version: '0.1.0',
    description:
      'Escrita interativa de um livro cumprindo missões, solo ou colaborativo. Narrador orquestrador (Oluap) e NPCs históricos com conhecimento próprio.',
    icon: 'BookOpen',
    requiredRole: 'professor',
  },

  routes: [
    {
      path: '/book_ia/preview/:slug',
      component: BookPreview,
      requiredRole: 'any',
      title: 'Book IA — Preview do livro',
    },
    {
      path: '/modules/book_ia/config/:tableId',
      component: BookIaGeneralConfig,
      requiredRole: 'professor',
      title: 'Configurar Book IA',
    },
    {
      path: '/modules/book_ia/monitor/:tableId',
      component: BookIaSessionMonitor,
      requiredRole: 'professor',
      title: 'Book IA — Acompanhar livros',
    },
  ],
}
